import { localDatabaseUrls } from "../backend/constants";
import { postAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import AlertManager from "../shared/Alert/Alert";

export const buildRejectDCCostBatchPayload = (selectedRows = [], tokenInfo = {}, comments = "Rejected selected items") => ({
  approvedBy: tokenInfo.username || "",
  comments,
  targetItems: selectedRows.map((row) => ({
    sku: row?.parsedSku || row?.sku || row?.skuId || row?.id || "",
    hqLine: row?.hqLine || "",
  })),
});

export const rejectDCCostBatch = async (batchId, selectedRows = []) => {
  if (!batchId) {
    AlertManager.error("Unable to reject DC cost batch.", { contactSupport: false });
    return null;
  }

  if (!Array.isArray(selectedRows) || !selectedRows.length) {
    AlertManager.warning("Select one or more items to reject.", { contactSupport: false });
    return null;
  }

  const tokenInfo = await getJWTToken();

  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const apiUrl = `${localDatabaseUrls.baseURL}api/v1/dc-cost/reject/${encodeURIComponent(batchId)}`;
  const requestBody = buildRejectDCCostBatchPayload(selectedRows, tokenInfo);
  const body = new Blob([JSON.stringify(requestBody)], { type: "application/json" });

  try {
    const response = await postAPI(apiUrl, body, tokenInfo);

    if (response?.ok) {
      AlertManager.success("Selected items rejected successfully.", { contactSupport: false });
      return response;
    }

    const errorData = await response?.json?.().catch(() => ({}));
    throw new Error(errorData?.message || "Unable to reject selected items.");
  } catch (error) {
    AlertManager.error(error?.message || "Unable to reject selected items.", { contactSupport: false });
    return null;
  }
};

export default rejectDCCostBatch;
